/**
 * In-memory cache for GetRestaurantLeadByZipcode responses.
 * Key: page + limit + zip filter.
 */
const cache = new Map();

export function marketingLeadCacheKey(page, limit, filters = {}) {
  const q = String(filters.q ?? '').trim().toLowerCase();
  const zipcode = String(filters.zipcode ?? '').trim().toLowerCase();
  const smsSent = filters.smsSent ?? 'all';
  const currentStatus = String(filters.currentStatus ?? '').trim() || 'all';
  const shouldContact = filters.shouldContact ?? 'all';
  return `${page}|${limit}|${q}|${zipcode}|${smsSent}|${currentStatus}|${shouldContact}`;
}

/**
 * @returns {{ rows: object[], totalLeads: number, refreshedAt: number } | null}
 */
export function getMarketingLeadPageCache(page, limit, filters) {
  return cache.get(marketingLeadCacheKey(page, limit, filters)) ?? null;
}

export function setMarketingLeadPageCache(page, limit, entry, filters) {
  const key = marketingLeadCacheKey(page, limit, filters);
  cache.set(key, {
    rows: entry.rows,
    totalLeads: entry.totalLeads,
    refreshedAt: entry.refreshedAt ?? Date.now(),
  });
}

export function invalidateMarketingLeadPageCache(page, limit, filters) {
  cache.delete(marketingLeadCacheKey(page, limit, filters));
}
